import { SkeletonRows } from '@/components/Skeleton';
import { PromptOptimizationJob } from '@/types/schema';

import { DurationChip, IDChip, StatusChip } from './Chip';
import { formatDate } from './utils';

const InfoRow = ({
  heading,
  children,
}: {
  heading: string;
  children: React.ReactNode;
}) => (
  <>
    <span className="text-sm text-secondary">{heading}: </span>
    <span className="text-sm text-secondary">{children}</span>
  </>
);

export const JobDetails = ({ job }: { job?: PromptOptimizationJob }) => {
  if (!job) {
    return <SkeletonRows rows={3} className="rounded" />;
  }
  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-row gap-2">
        <div className="text-xl font-medium text-primary">{job.id}</div>
        <div className="flex-grow" />
        <StatusChip status={job.status} />
        <DurationChip startTime={job.created_at} endTime={job.updated_at} />
        <IDChip value={job.id} />
      </div>
      <div className="grid grid-cols-[100px_auto] gap-y-2">
        {job?.created_at && (
          <InfoRow heading="Created at">{formatDate(job.created_at)}</InfoRow>
        )}
        {job?.updated_at && (
          <InfoRow heading="Updated at">{formatDate(job.updated_at)}</InfoRow>
        )}
        <InfoRow heading="Algorithm">{job?.algorithm}</InfoRow>
      </div>
    </div>
  );
};
